// extracted by mini-css-extract-plugin
module.exports = {"borderGrey":"#B5B4B5","zIndexModalBackdrop":"1040","question":"FoyIssPeHDzRi9vD","text":"_1HBRyrB70SMvf9eA"};